import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import Public from './Public';

export default function CroatianPublic() {
  const { setLang } = useLanguage();

  useEffect(() => {
    setLang('hr');
  }, [setLang]);

  return <Public />;
}
